import { render, staticRenderFns } from "./Dots.vue?vue&type=template&id=0604f4fc&scoped=true&"
import script from "./Dots.vue?vue&type=script&lang=ts&"
export * from "./Dots.vue?vue&type=script&lang=ts&"
import style0 from "./Dots.vue?vue&type=style&index=0&id=0604f4fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0604f4fc",
  null
  
)

export default component.exports